import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { Datetime } from 'vue-datetime';
import axios from "axios";

import 'vue-datetime/dist/vue-datetime.css'

Vue.component('datetime', Datetime);
Vue.config.productionTip = false;

Vue.mixin({
  data: function () {
    return {
      baseUrl: 'https://api.transbits.nl/qa',
    }
  }
})



const qaApi = axios.create({
  baseURL: 'https://api.transbits.nl/qa'
});
qaApi.interceptors.request.use(
  config => {
      const user = store.getters.user;
      console.log(user);
      user?.getIdToken().then((token : any) => config.headers['Authorization'] = token)
      return config;
  },
  error => {
      Promise.reject(error)
  });
Vue.prototype.$http = qaApi;

new Vue({
  store,
  beforeCreate() { 
    this.$store.dispatch('reloadUser');
  },
  router,
  vuetify,
  render: h => h(App),
}).$mount("#app");
